import React, { useEffect } from 'react'
import authActions from 'pages/Auth/actions'
import GlobalBusy from 'components/app/GlobalBusy'

const LogoutContainer = () => {
    const { logout } = authActions()

    useEffect(() => {
        logout()
    }, [logout])

    return <GlobalBusy />
}

export default LogoutContainer
